import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Footer from './Footer';
import './Home.css';

const Home = () => {

  const [queryForm, setQueryForm] = useState({ name: '', email: '', message: '' });
  const [querySent, setQuerySent] = useState(false);
  const [showAllPartners, setShowAllPartners] = useState(false);
  const [failedImages, setFailedImages] = useState(new Set());
  const [statsAnimated, setStatsAnimated] = useState(false);
  const [animatedStats, setAnimatedStats] = useState({
    years: 0,
    medicines: 0,
    customers: 0,
    partners: 0,
  });

  // All partner logos
  const allPartnerLogos = [
    { src: '/All.png', alt: 'Partner Logo' },
    { src: '/Al.png', alt: 'Partner Logo' },
    { src: '/Ar.jpg', alt: 'Partner Logo' },
    { src: '/Az.png', alt: 'Partner Logo' },
    { src: '/B.webp', alt: 'Partner Logo' },
    { src: '/Bh.jpg', alt: 'Partner Logo' },
    { src: '/Bio.png', alt: 'Partner Logo' },
    { src: '/Cipla_logo.svg.png', alt: 'Cipla Logo' },
    { src: '/images.png', alt: 'Partner Logo' },
    { src: '/CA.jpg', alt: 'Partner Logo' },
    { src: '/co.jpg', alt: 'Partner Logo' },
    { src: '/dr.png', alt: 'Partner Logo' },
    { src: '/ei.png', alt: 'Partner Logo' },
    { src: '/em.png', alt: 'Partner Logo' },
    { src: '/fd.jpg', alt: 'Partner Logo' },
    { src: '/fp.png', alt: 'Partner Logo' },
    { src: '/gl.jpg', alt: 'Partner Logo' },
    { src: '/gl.png', alt: 'Partner Logo' },
    { src: '/gsk.jpg', alt: 'Partner Logo' },
    { src: '/hm.jpg', alt: 'Partner Logo' },
    { src: '/ht.png', alt: 'Partner Logo' },
    { src: '/in.png', alt: 'Partner Logo' },
    { src: '/ip.png', alt: 'Partner Logo' },
    { src: '/jb.png', alt: 'Partner Logo' },
    { src: '/jk.png', alt: 'Partner Logo' },
    { src: '/ky.png', alt: 'Partner Logo' },
    { src: '/la.png', alt: 'Partner Logo' },
    { src: '/ll.png', alt: 'Partner Logo' },
    { src: '/Lp.png', alt: 'Partner Logo' },
    { src: '/mr.png', alt: 'Partner Logo' },
    { src: '/mc.png', alt: 'Partner Logo' },
    { src: '/mn.png', alt: 'Partner Logo' },
    { src: '/ms.png', alt: 'Partner Logo' },
    { src: '/my.png', alt: 'Partner Logo' },
    { src: '/pg.jpg', alt: 'Partner Logo' },
    { src: '/nt.png', alt: 'Partner Logo' },
    { src: '/nv.png', alt: 'Partner Logo' },
    { src: '/ok.png', alt: 'Partner Logo' },
    { src: '/pa.jpg', alt: 'Partner Logo' },
    { src: '/pr.png', alt: 'Partner Logo' },
    { src: '/pz.png', alt: 'Partner Logo' },
    { src: '/rc.png', alt: 'Partner Logo' },
    { src: '/rs.png', alt: 'Partner Logo' },
    { src: '/sa.jpg', alt: 'Partner Logo' },
    { src: '/sh.jpg', alt: 'Partner Logo' },
    { src: '/sn.png', alt: 'Partner Logo' },
    { src: '/sv.jpg', alt: 'Partner Logo' },
    { src: '/th.jpg', alt: 'Partner Logo' },
    { src: '/tr.jpg', alt: 'Partner Logo' },
    { src: '/us.png', alt: 'Partner Logo' },
    { src: '/wl.jpg', alt: 'Partner Logo' },
    { src: '/wn.jpg', alt: 'Partner Logo' },
    { src: '/z.jpg', alt: 'Partner Logo' },
    { src: '/zy.png', alt: 'Partner Logo' },
  ];

  const visibleLogos = allPartnerLogos.slice(0, 12);
  const hiddenLogos = allPartnerLogos.slice(12);

  const handleImageError = (e, logo) => {
    // Hide the image container if image fails to load
    setFailedImages(prev => new Set(prev).add(logo.src));
  };

  const stats = [
    { label: 'Years of Trust', value: 58, suffix: '+' },
    { label: 'Medicines Available', value: 50000, suffix: '+' },
    { label: 'Happy Customers', value: 250000, suffix: '+' },
    { label: 'Partners', value: 300, suffix: '+' },
  ];

  const journeySteps = [
    { year: '1966', title: 'The Foundation', description: 'Founded as a modest pharmaceutical trading firm in Northern India.' },
    { year: 'Evolution', title: 'Healthcare Supply Chain', description: 'Transformed into a multi-dimensional healthcare supply chain organization.' },
    { year: 'Expanding', title: 'Regional Impact', description: 'Expanded into hospital pharmacy management and regional distribution.' },
    { year: 'Today', title: 'Market Leader', description: 'Serving retail chains, hospitals, and corporate healthcare providers across India.' }
  ];

  const expertiseItems = [
    { title: 'Pharmaceuticals', description: 'All major therapeutic segments with authentic products.', icon: '💊' },
    { title: 'Surgical & Implants', description: 'Quality surgical consumables and advanced medical implants.', icon: '🏥' },
    { title: 'Medical Devices', description: 'Direct partnerships for high-end medical equipment and devices.', icon: '🩺' },
    { title: 'FMCG & Diagnostics', icon: '🧴', description: 'Comprehensive healthcare product and diagnostic solutions.' }
  ];



  const whyChooseUsData = [
    { text: '58+ Years Industry Legacy', icon: '📜' },
    { text: 'Direct accounts with major pharma companies', icon: '🤝' },
    { text: 'Integrated Pharma + Devices + FMCG model', icon: '🔄' },
    { text: 'Robust IT & Inventory Systems', icon: '💻' },
    { text: 'Dedicated Hospital & Institutional verticals', icon: '🏢' },
    { text: 'Presence across key Indian markets', icon: '📍' }
  ];

  const presenceCities = [
    { name: 'Jaipur', region: 'Rajasthan' },
    { name: 'Indore', region: 'Madhya Pradesh' },
    { name: 'New Delhi', region: 'NCR' },
    { name: 'Lucknow', region: 'Uttar Pradesh' },
    { name: 'Ahmedabad', region: 'Gujarat' }
  ];

  const missionPoints = [
    { title: 'Principals', text: 'Transparent market access and reach.' },
    { title: 'Customers', text: 'Uninterrupted product availability.' },
    { title: 'Patients', text: 'Affordable, high-quality healthcare care.' }
  ];

  const branches = [
    {
      name: 'Tara Medicos Private Limited - Jaipur',
      address: ' A-7, Bais Godam Main Rd, opposite Bank of Baroda, Bais Godam, Jaipur, Rajasthan 302006',
      phone: '0141 3100030',
      hours: 'Mon-Sat • 08:00 - 20:00 ',
      services: 'Pharmaceutical Wholesale & Distribution Services ',
    },
    {
      name: 'Tara Medicos Private Limited (Branch) - Jaipur',
      address: 'G-5/6, Mayur Tower, Nehru Bazar, Chaura Rasta, Jaipur, Rajasthan 302003',
      phone: '0141 2314253',
      hours: 'Mon-Sat • 08:00 - 20:00 ',
      services: 'Pharmaceutical Wholesale & Distribution Services',
    },
    {
      name: 'Tara Medicos Wellness Private Limited - Indore',
      address: ' 79-80, Dewas Naka, Pipliya Kumar, Indore, Madhya Pradesh 452010',
      phone: '0731 4109963',
      hours: 'Mon-Sat • 08:00 - 20:00 ',
      services: 'Pharmaceutical Wholesale & Distribution Services',
    },
    {
      name: 'Tara Medicos Wellness Private Limited - Lucknow',
      address: '  C-1/5, First floor, Transport Nagar Industrial Area Phase-2, Lucknow, Uttar Pradesh 226012',
      phone: '0522 4230342',
      hours: 'Mon-Sat • 08:00 - 20:00 ',
      services: 'Pharmaceutical Wholesale & Distribution Services',
    },

  ];



  // Animate stats counter when section comes into view
  useEffect(() => {
    const statsSection = document.querySelector('.stats-section');
    if (!statsSection || statsAnimated) return;

    const animateStats = () => {
      const duration = 2000; // 2 seconds
      const steps = 60;
      const interval = duration / steps;

      stats.forEach((stat, index) => {
        let currentStep = 0;
        const increment = stat.value / steps;

        const timer = setInterval(() => {
          currentStep++;
          const currentValue = Math.min(Math.floor(increment * currentStep), stat.value);

          setAnimatedStats((prev) => {
            const newStats = { ...prev };
            switch (index) {
              case 0:
                newStats.years = currentValue;
                break;
              case 1:
                newStats.medicines = currentValue;
                break;
              case 2:
                newStats.customers = currentValue;
                break;
              case 3:
                newStats.partners = currentValue;
                break;
              default:
                break;
            }
            return newStats;
          });

          if (currentStep >= steps) {
            clearInterval(timer);
          }
        }, interval);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !statsAnimated) {
            setStatsAnimated(true);
            animateStats();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(statsSection);

    return () => {
      observer.disconnect();
    };
  }, [statsAnimated, stats]);

  const formatStatValue = (value, index) => {
    const suffix = stats[index].suffix;
    if (value >= 1000) {
      const thousands = value / 1000;
      // If it's a whole number, don't show decimal
      if (thousands % 1 === 0) {
        return thousands + 'K' + suffix;
      }
      // Otherwise show one decimal place
      return thousands.toFixed(1) + 'K' + suffix;
    }
    return value + suffix;
  };

  const handleQuerySubmit = async (e) => {
    e.preventDefault();
    if (!queryForm.name || !queryForm.email || !queryForm.message) {
      return;
    }

    try {
      const response = await api.post('/queries', {
        name: queryForm.name,
        email: queryForm.email,
        message: queryForm.message
      });

      if (response.data.success) {
        setQuerySent(true);
        setQueryForm({ name: '', email: '', message: '' });
        setTimeout(() => setQuerySent(false), 3000);
      }
    } catch (error) {
      console.error('Error submitting query:', error);
      alert('Failed to send message. Please try again later.');
    }
  };

  return (
    <div className="home">
      <section id="home" className="hero-section">
        <div className="hero-content">
          <div className="hero-badge">Established Since 1966</div>
          <h1 className="hero-title">
            Six Decades of Trust <br />
            <span>in Healthcare Distribution</span>
          </h1>
          <p className="hero-subtitle">
            A legacy of commitment and excellence, growing from a modest trading firm into Northern India’s most trusted pharmaceutical supply chain partner.
          </p>
        </div>
      </section>

      <section id="about" className="journey-section">
        <div className="container">
          <div className="journey-grid">
            <div className="journey-info" style={{ textAlign: 'center' }}>
              <h2 className="section-title">Our Journey</h2>
              <p className="journey-desc">
                What began as a wholesale and retail pharmacy venture has transformed into a multi-dimensional healthcare supply chain organization. We continuously evolve to ensure uninterrupted access to quality products.
              </p>
              <div className="journey-timeline">
                {journeySteps.map((step, index) => (
                  <div key={index} className="timeline-card">
                    <span className="timeline-badge">{step.year}</span>
                    <h4>{step.title}</h4>
                    <p>{step.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container stats-grid">
          {stats.map((item, index) => {
            let displayValue;
            switch (index) {
              case 0:
                displayValue = animatedStats.years;
                break;
              case 1:
                displayValue = animatedStats.medicines;
                break;
              case 2:
                displayValue = animatedStats.customers;
                break;
              case 3:
                displayValue = animatedStats.partners;
                break;
              default:
                displayValue = 0;
            }
            return (
              <div key={item.label} className="stat-card">
                <div className="stat-value">{formatStatValue(displayValue, index)}</div>
                <div className="stat-label">{item.label}</div>
              </div>
            );
          })}
        </div>
      </section>

      <section id="expertise" className="expertise-section">
        <div className="container">
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">Specializing in single-point procurement and end-to-end supply chain solutions</p>
          <div className="expertise-grid">
            {expertiseItems.map((item, index) => (
              <div key={index} className="expertise-box">
                <div className="expertise-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      <section id="features" className="features-section">
        <div className="container">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="why-us-grid">
            {whyChooseUsData.map((item, index) => (
              <div key={index} className="why-us-card">
                <div className="why-us-icon">{item.icon}</div>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>



      <section className="mission-section">
        <div className="container">
          <div className="mission-wrapper">
            <h2 className="section-title">Our Mission</h2>
            <p className="mission-main-text">To deliver reliable, ethical, and technology-enabled healthcare distribution that empowers the entire healthcare ecosystem.</p>
            <div className="mission-grid">
              {missionPoints.map((point, index) => (
                <div key={index} className="mission-card-item">
                  <h4>{point.title}</h4>
                  <p>{point.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>



      <section id="branches" className="branches-section">
        <div className="container">
          <h2 className="section-title">Our Branches & Presence</h2>

          <div className="branches-grid">
            {branches.map((branch) => (
              <div key={branch.name} className="branch-card">
                <div className="branch-header">
                  <div className="branch-icon">🏥</div>
                  <div>
                    <div className="branch-status">Operational</div>
                    <h3>{branch.name}</h3>
                    <p className="branch-address">
                      <span className="address-icon">📍</span> {branch.address}
                    </p>
                  </div>
                </div>
                <div className="branch-body">
                  <div className="branch-info">
                    <span className="label">📞 Phone:</span>
                    <span className="value">{branch.phone}</span>
                  </div>
                  <div className="branch-info">
                    <span className="label">⏰ Hours:</span>
                    <span className="value">{branch.hours}</span>
                  </div>
                  <div className="branch-info">
                    <span className="label">🛠️ Services:</span>
                    <span className="value">{branch.services}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="presence-integrated">
            <h3 className="presence-subtitle-main">Pan-India Delivery Network</h3>
            <div className="presence-grid">
              {presenceCities.map((city, index) => (
                <div key={index} className="city-card">
                  <div className="city-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12 22C14 18 20 15.4183 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 15.4183 10 18 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <div className="city-card-info">
                    <h3>{city.name}</h3>
                    <p>{city.region}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="partners" className="partners-section">
        <div className="container">
          <h2 className="section-title">Our Principals</h2>
          <p className="partners-subtitle">We work with leading pharmaceutical companies to bring you the best healthcare solutions</p>
          <div className={`partners-container ${showAllPartners ? 'show-all' : ''}`}>
            <div className="partners-slider">
              {visibleLogos.map((logo, index) => (
                !failedImages.has(logo.src) && (
                  <div key={`visible-${index}`} className="partner-logo">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      onError={(e) => handleImageError(e, logo)}
                      loading="lazy"
                    />
                  </div>
                )
              ))}
              {showAllPartners && hiddenLogos.map((logo, index) => (
                !failedImages.has(logo.src) && (
                  <div key={`hidden-${index}`} className="partner-logo">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      onError={(e) => handleImageError(e, logo)}
                      loading="lazy"
                    />
                  </div>
                )
              ))}
              {!showAllPartners && visibleLogos.map((logo, index) => (
                !failedImages.has(logo.src) && (
                  <div key={`duplicate-${index}`} className="partner-logo">
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      onError={(e) => handleImageError(e, logo)}
                      loading="lazy"
                    />
                  </div>
                )
              ))}
            </div>
          </div>
          <div className="partners-actions">
            <button
              className="show-all-btn"
              onClick={() => setShowAllPartners(!showAllPartners)}
            >
              {showAllPartners ? 'Show Less' : 'Show All'}
            </button>
          </div>
        </div>
      </section>

      <section id="contact" className="query-section">
        <div className="container">
          <div className="query-content-wrapper">
            <div className="query-info">
              <h2 className="query-title-main">Get In Touch</h2>
              <p className="query-description">
                Have a question or need assistance? We're here to help. Send us a message and we'll respond as soon as possible.
              </p>
              <div className="query-contact-details">
                <div className="contact-detail-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h4>Email Us</h4>
                    <a href="mailto:info@taramed.net">info@taramed.net</a>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <div className="contact-icon">📞</div>
                  <div>
                    <h4>Call Us</h4>
                    <a href="tel:01413100030">0141 3100030</a>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <div className="contact-icon">🕒</div>
                  <div>
                    <h4>Business Hours</h4>
                    <p>Monday - Saturday: 08:00 AM - 08:00 PM</p>
                  </div>
                </div>
                <div className="contact-detail-item">
                  <div className="contact-icon">
                    <img src="/LO.png" alt="Live Order" className="contact-icon-image" />
                  </div>
                  <div>
                    <h4>Tara Connect Website</h4>
                    <a href="https://online.taramed.in/" target="_blank" rel="noopener noreferrer">
                      Tara Connect
                    </a>
                    <div className="app-store-links">
                      <a
                        href="https://play.google.com/store/apps/details?id=com.liveorder"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-store-link"
                        aria-label="Get it on Google Play"
                      >
                        <img
                          src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                          alt="Get it on Google Play"
                          className="app-store-badge"
                        />
                      </a>
                      <a
                        href="https://apps.apple.com/in/app/liveorder-csquare/id1660025243"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-store-link"
                        aria-label="Download on the App Store"
                      >
                        <img
                          src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1276560000"
                          alt="Download on the App Store"
                          className="app-store-badge"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <form className="query-form" onSubmit={handleQuerySubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  id="name"
                  type="text"
                  placeholder="Enter your full name"
                  value={queryForm.name}
                  onChange={(e) => setQueryForm({ ...queryForm, name: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  placeholder="Enter your email address"
                  value={queryForm.email}
                  onChange={(e) => setQueryForm({ ...queryForm, email: e.target.value })}
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message">Your Message</label>
                <textarea
                  id="message"
                  placeholder="Tell us how we can help you..."
                  value={queryForm.message}
                  onChange={(e) => setQueryForm({ ...queryForm, message: e.target.value })}
                  rows="5"
                  required
                />
              </div>
              <button type="submit" className="query-submit-btn">
                <span>Send Message</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.3333 1.66667L9.16667 10.8333M18.3333 1.66667L12.5 18.3333L9.16667 10.8333M18.3333 1.66667L1.66667 7.5L9.16667 10.8333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              {querySent && (
                <div className="query-success-message">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <span>Message sent successfully! We'll get back to you soon.</span>
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div >
  );
};

export default Home;
